export const UseNewColorScheme = 'app_branding_-_use_new_color_scheme'
